(function () {
  'use strict';

  function setupCursor() {
    const cursor = document.getElementById('loomforma-cart-cursor');
    if (!cursor || !window.matchMedia('(min-width: 1024px)').matches) return;

    document.addEventListener('mousemove', function (event) {
      cursor.style.left = event.clientX + 'px';
      cursor.style.top = event.clientY + 'px';
    });

    document.querySelectorAll('a, button').forEach(function (element) {
      element.addEventListener('mouseenter', function () {
        cursor.style.transform = 'translate(-50%, -50%) scale(2.5)';
        cursor.style.backgroundColor = 'transparent';
        cursor.style.border = '1px solid #1C1C1C';
      });

      element.addEventListener('mouseleave', function () {
        cursor.style.transform = 'translate(-50%, -50%) scale(1)';
        cursor.style.backgroundColor = '#1C1C1C';
        cursor.style.border = 'none';
      });
    });
  }

  function setupQuantityControls() {
    const form = document.getElementById('loomforma-cart-form');
    if (!form) return;

    const updateSubmitter = form.querySelector('[data-cart-update]');
    let submitTimeout = null;

    function queueUpdate() {
      window.clearTimeout(submitTimeout);
      submitTimeout = window.setTimeout(function () {
        if (updateSubmitter && form.requestSubmit) {
          form.requestSubmit(updateSubmitter);
          return;
        }

        if (form.requestSubmit) {
          form.requestSubmit();
          return;
        }

        form.submit();
      }, 120);
    }

    form.querySelectorAll('[data-qty-action]').forEach(function (button) {
      button.addEventListener('click', function () {
        const line = button.getAttribute('data-line');
        const action = button.getAttribute('data-qty-action');
        const input = form.querySelector('[data-line-input="' + line + '"]');
        const display = form.querySelector('[data-qty-display="' + line + '"]');

        if (!input || !display) return;

        const step = Number(input.getAttribute('step') || 1);
        const min = Number(input.getAttribute('min') || 0);
        const maxAttr = input.getAttribute('max');
        const max = maxAttr ? Number(maxAttr) : null;
        const current = Number(input.value || 0);

        let next = current;
        if (action === 'plus') next += step;
        if (action === 'minus') next -= step;

        if (next < min) next = min;
        if (max !== null && next > max) next = max;
        if (next === current) return;

        input.value = String(next);
        display.textContent = String(next).padStart(2, '0');
        queueUpdate();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    setupCursor();
    setupQuantityControls();
  });
})();
